var exports = {
  "k": "x936d19a0--26a6ff--container",
};

module.exports = exports;
